import React, { useState, useEffect, useCallback } from 'react';
import { TextField, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from 'redux-lib/actions/actions';
import GRAPHQL_API from 'api/graphql';
import { getPAOptions } from 'utils/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      width: '25ch',
      paddingTop: 16
    },
  },
  select: {
    '& .MuiSelect-icon': {
      color: '#3f88b1'
    }
  }
}));

function PersonalAccident(props) {
  const classes = useStyles(); 

  const dispatch = useDispatch();
  const states = useSelector(state => {
    return state.globalStates
  })

  const car_type = states ? states.car_type ? states.car_type : "" : "";
  const pa = states ? states.pa ? states.pa : "" : "";
  const pa_options = states ? states.pa_options ? states.pa_options : [] : [];
 
  useEffect(() => {
    dispatch({
      type: ACTIONS.UPDATE_PA_OPTIONS,
      payload: getPAOptions()
    })
  }, [car_type])

  const handleChange = (e) => {
    dispatch({
      type: ACTIONS.UPDATE_PA,
      payload: e.target.value
    })
  }

  const renderPAOptions = () => {
    if( pa_options.length ) {
      const options = pa_options.map((option, key) => {
        const textValue = option.toLocaleString();
        return <MenuItem key={ `bipd-item-${ key }` } value={option}>
          <span>P</span>&nbsp;<span>{ textValue }</span>
        </MenuItem>
      })
      return options;
    } else {
      return(
        <MenuItem value="" disabled>
          <em>None</em>
        </MenuItem>)
    }
  }

  const clearStates = (statesToClear) => {
    statesToClear.forEach((state) => {
      dispatch({
        type: `UPDATE_${ state.toUpperCase() }`,
        payload: ""
      })
    })
  }

  return(
    <div className={ classes.root }>
      <TextField
        autoComplete="on"
        id="standard-select-pa"
        select
        name="pa"
        label="Personal Accident Coverage"
        value={ pa }
        className={ classes.select }
        onChange={handleChange}
        InputLabelProps={{
          shrink: true
        }}
      >
        { renderPAOptions() }
      </TextField>
    </div>
  )
}

export default PersonalAccident;